import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function AuthCallback() {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/connexion"); return; }
      try {
        const { data } = await api.googleSession(sessionId);
        await setSession(data.token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user.role === "admin" ? "/admin" : data.user.role === "expert" ? "/expert" : "/tableau-de-bord");
      } catch {
        navigate("/connexion");
      }
    })();
  }, [navigate, setSession]);

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center text-celeste-lilas">
      <Loader2 className="h-10 w-10 animate-spin text-celeste-or" />
      <p className="mt-4">Connexion en cours…</p>
    </div>
  );
}
